
import React from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BuildingsSTR from "../pages/buildings-str/page";
import VancouverSTR from "../pages/vancouver-str/page";
import NorthVancouverSTR from "../pages/north-vancouver-str/page";
import SurreySTR from "../pages/surrey-str/page";
import LangleySTR from "../pages/langley-str/page";
import AlbertaSTR from "../pages/alberta-str/page";
import BurnabySTR from "../pages/burnaby-str/page";
import TorontoSTR from "../pages/toronto-str/page";
import VictoriaSTR from "../pages/victoria-str/page";
import WhistlerSTR from "../pages/whistler-str/page";
import AssessmentPage from "../pages/assessment/page";
import EligibilityResultsPage from "../pages/eligibility-results/page";
import BookCallPage from "../pages/book-call/page";
import BookingConfirmationPage from "../pages/book-call/confirmation/page";
import RevenueCalculatorPage from "../pages/revenue-calculator/page";
import ComplianceReviewPage from "../pages/compliance-review/page";
import STRCohostingPage from "../pages/str-cohosting/page";
import MediumTermRentalsPage from "../pages/medium-term-rentals/page";
import ListingSetupPage from "../pages/listing-setup/page";
import FAQPage from "../pages/faq/page";
import ContactPage from "../pages/contact/page";

/**
 * Application routes configuration.
 * Each route maps a URL path to a React component.
 * Errors are caught at runtime via a fallback NotFound component.
 */
const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/buildings-that-allow-str",
    element: <BuildingsSTR />,
  },
  {
    path: "/vancouver-short-term-rental-rules",
    element: <VancouverSTR />,
  },
  {
    path: "/north-vancouver-str-bylaws",
    element: <NorthVancouverSTR />,
  },
  {
    path: "/surrey-rental-regulations",
    element: <SurreySTR />,
  },
  {
    path: "/langley-str-licensing",
    element: <LangleySTR />,
  },
  {
    path: "/alberta-short-term-rental-regulations",
    element: <AlbertaSTR />,
  },
  {
    path: "/burnaby-str-regulations",
    element: <BurnabySTR />,
  },
  {
    path: "/toronto-str-regulations",
    element: <TorontoSTR />,
  },
  {
    path: "/victoria-str-regulations",
    element: <VictoriaSTR />,
  },
  {
    path: "/whistler-str-regulations",
    element: <WhistlerSTR />,
  },
  {
    path: "/property-assessment",
    element: <AssessmentPage />,
  },
  {
    path: "/book-call",
    element: <BookCallPage />,
  },
  {
    path: "/book-call/confirmation",
    element: <BookingConfirmationPage />,
  },
  {
    path: "/eligibility-results",
    element: <EligibilityResultsPage />,
  },
  {
    path: "/revenue-calculator",
    element: <RevenueCalculatorPage />,
  },
  {
    path: "/compliance-review",
    element: <ComplianceReviewPage />,
  },
  {
    path: "/str-cohosting",
    element: <STRCohostingPage />,
  },
  {
    path: "/medium-term-rentals",
    element: <MediumTermRentalsPage />,
  },
  {
    path: "/listing-setup",
    element: <ListingSetupPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    // Catch‑all route for undefined paths
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
